module.exports = __webpack_public_path__ + "img/icon_pjyl.bf4ec69d.png";